import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfServices from '../pages/TermsOfServices/TermsOfServices';
import { PaymentProvider } from './hooks/PaymentContext';

import Modal from './Modal/Modal';
import AddBuildingAddress from './Modals/AddBuildingAddress/AddBuildingAddress';
import AddHome from './Modals/AddHome/AddHome';
import AllGiftCards from './Modals/AllGiftCards/AllGiftCards';

import CompleteBuilding from './Modals/CompleteBuilding/CompleteBuilding';
import { DeleteAccount } from './Modals/DeleteAccount/DeleteAccount';
import { DownloadApp } from './Modals/DownloadApp/DownloadApp';
import { InAppReviewModal } from './Modals/InAppReviewModal/InAppReviewModal';
import { EnableReportingModal } from './Modals/EnableReportingModal/EnableReportingModal';
import IdentityVerification from './Modals/IdentityVerification/IdentityVerification';
import IDVChangeRequest from './Modals/IdentityVerification/IDVChangeRequest';
import IDVDeclined from './Modals/IdentityVerification/IDVDeclined';
import IDVSuccess from './Modals/IdentityVerification/IDVSuccess';
import PendingScreen from './Modals/IdentityVerification/PendingScreen';
import IncompleteIdentity from './Modals/IncompleteIdentity/IncompleteIdentity';
import MFASettings from './Modals/MFASettings/MFASettings';
import MyHomes from './Modals/MyHomes/MyHome';
import PastTransactions from './Modals/PastTransactions/PastTransactions';
import AddCard from './Modals/Payment/AddCard/AddCard';
import AddPaymentMethodCard from './Modals/Payment/AddPaymentMethodCard/AddPaymentMethodCard';
import CardAuthDisclosure from './Modals/Payment/CardAuthDisclosure/CardAuthDisclosure';
import AddBankAccount from './Modals/Payment/AddBankAccount/AddBankAccount';
import PadTerms from './Modals/Payment/PadTerms/PadTerms';
import PadVerificationMethod from './Modals/Payment/PadVerificationMethod/PadVerificationMethod';
import { PayWithCrypto } from './Modals/Payment/Crypto/PayWithCrypto';
import { PaymentStatus } from './Modals/Payment/PaymentStatus/PaymentStatus';
import PaymentSchedule from './Modals/PaymentSchedule/PaymentSchedule';

import PayNumber from './Modals/PayNumberModal/PayNumber';
import { Profile } from './Modals/Profile/Profile';
import PropertyUpdated from './Modals/PropertyUpdated/PropertyUpdated';
import { EVoucher } from './Modals/EVoucher/EVoucher';
import { RedeemGiftCard } from './Modals/RedeemGiftCard/RedeemGiftCard';

import { RedeemPoints } from './Modals/RedeemPoints/RedeemPoints';
import { ReferralHistory } from './Modals/ReferralHistory/ReferralHistory';
import { RemoveCard } from './Modals/Payment/RemoveCard/RemoveCard';
import { ResetPasswordModal } from './Modals/ResetPasswordModal/ResetPasswordModal';
import { PhoneSettingsModal } from './Modals/PhoneSettingsModal/PhoneSettingsModal';
import ReturnToDashboard from './Modals/ReturnToDashboard/ReturnToDashboard';
import { Rewards } from './Modals/Rewards/Rewards';

import SelectProperty from './Modals/SelectProperty/SelectProperty';
import { SubscriptionDetails } from './Modals/SubscriptionDetail/SubscriptionDetails';

import { SubscriptionPoints } from './Modals/SubscriptionPoints/SubscriptionPoints';
import { SuccessfulEquifaxReporting } from './Modals/SuccessfulEquifaxReporting/SuccessfulEquifaxReporting';
import SuccessfulProperty from './Modals/SuccessfulProperty/SuccessfulProperty';
import SuccessGiftCard from './Modals/SuccessGiftCard/SuccessGiftCard';
import SuccessMessage from './Modals/SuccessMessage/SuccessMessage';
import TransactionDetail from './Modals/TransactionDetail/TransactionDetail';
import UnsubscribeCredit from './Modals/UnsubscribeCredit/UnsubscribeCredit';

import UploadPhoto from './Modals/UploadPhoto/UploadPhoto';
import RemoveMFA from './Modals/VerificationMFA/RemoveMFA';
import { CancelSubscription } from './Modals/Payment/CancelSubscription/CancelSubscription';
import { UpdateSubscriptionPaymentMethod } from './Modals/Payment/UpdateSubscriptionPaymentMethod/UpdateSubscriptionPaymentMethod';
import GiftCardDetails from './Modals/AllGiftCards/GiftCardDetails';
import { ViewEquifaxDetails } from './Modals/ViewEquifaxDetails/ViewEquifaxDetails';
import { AddCardSuccess } from './Modals/Payment/AddCard/AddCardSuccess/AddCardSuccess';

const ModalContainer = ({ safeCharge }: { safeCharge: any }) => {
  /**
   * ModalContainer renders all modal components used across the application.
   *
   * Usage:
   * - Each <Modal /> receives a unique `id`. To open a modal, call `setModal('id')` from the modal context.
   * - Optional props:
   *   - `closeOnClickAway` (default: true): disables modal close when clicking outside.
   *   - `background`: allows custom overlay color if needed.
   *
   */
  return (
    <>
      <Modal id={'rnt-not-found'}>
        <PayNumber />
      </Modal>
      <Modal id={'property-successful'}>
        <SuccessfulProperty />
      </Modal>
      <Modal id={'property-updated'}>
        <PropertyUpdated />
      </Modal>

      <Modal id={'change-rnt-number'}>
        <PayNumber isRNTChange={true} />
      </Modal>
      <Modal id={'terms-services'} closeOnClickAway={false}>
        <TermsOfServices />
      </Modal>
      <Modal id={'privacy-policy'}>
        <PrivacyPolicy />
      </Modal>
      <Modal id={'payment-schedule'}>
        <PaymentSchedule />
      </Modal>
      <Modal id={'reset-password'}>
        <ResetPasswordModal />
      </Modal>
      <Modal id={'phone-settings'} closeOnClickAway={false}>
        <PhoneSettingsModal />
      </Modal>
      <Modal id={'add-card'} closeOnClickAway={false}>
        <AddCard safeCharge={safeCharge} />
      </Modal>
      <Modal id={'add-payment-method'}>
        <AddPaymentMethodCard />
      </Modal>
      <Modal id={'card-auth-disclosure'} closeOnClickAway={false}>
        <CardAuthDisclosure />
      </Modal>
      <Modal id={'add-bank-account'} closeOnClickAway={false}>
        <AddBankAccount />
      </Modal>
      <Modal id={'pad-verification-method'} closeOnClickAway={false}>
        <PadVerificationMethod />
      </Modal>
      <Modal id={'pad-terms'} closeOnClickAway={false}>
        <PadTerms />
      </Modal>

      <Modal id={'remove-card'}>
        <RemoveCard />
      </Modal>

      <Modal id={'transaction-detail'}>
        <TransactionDetail />
      </Modal>
      <Modal id={'return-to-dashboard'}>
        <ReturnToDashboard />
      </Modal>

      <Modal id={'success-modal'}>
        <SuccessMessage />
      </Modal>

      <Modal id={'remove-mfa'} closeOnClickAway={false}>
        <RemoveMFA />
      </Modal>
      <Modal id={'incomplete-identity'}>
        <IncompleteIdentity />
      </Modal>
      <Modal id={'unsubscribe-credit'}>
        <UnsubscribeCredit />
      </Modal>
      <Modal id={'select-property'} closeOnClickAway={false}>
        <SelectProperty />
      </Modal>

      <Modal id={'redeem-gift-card'} closeOnClickAway={false}>
        <RedeemGiftCard />
      </Modal>
      <Modal id='e-voucher' closeOnClickAway={false}>
        <EVoucher />
      </Modal>
      <Modal id='success-gift-card'>
        <SuccessGiftCard />
      </Modal>
      <Modal id='profile' closeOnClickAway={false}>
        <Profile />
      </Modal>
      <Modal id='download-app'>
        <DownloadApp />
      </Modal>
      <Modal id='delete-account' closeOnClickAway={false}>
        <DeleteAccount />
      </Modal>
      <Modal id='in-app-review'>
        <InAppReviewModal />
      </Modal>
      <Modal id='referral-history'>
        <ReferralHistory />
      </Modal>
      <Modal id='upload-photo'>
        <UploadPhoto />
      </Modal>
      <Modal id='enable-reporting' closeOnClickAway={false}>
        <EnableReportingModal />
      </Modal>
      <Modal id='past-transactions' closeOnClickAway={false}>
        <PastTransactions />
      </Modal>
      <Modal id='rewards' closeOnClickAway={false}>
        <Rewards />
      </Modal>
      <Modal id='redeem-points' closeOnClickAway={false}>
        {' '}
        <RedeemPoints />
      </Modal>
      <Modal id={'my-homes'} closeOnClickAway={false}>
        <MyHomes />
      </Modal>
      <Modal id='complete-building' closeOnClickAway={false}>
        <CompleteBuilding />
      </Modal>
      <Modal id={'add-home'} closeOnClickAway={false}>
        <AddHome />
      </Modal>
      <Modal id={'add-building-address'} closeOnClickAway={false}>
        <AddBuildingAddress />
      </Modal>
      <Modal id='subscription-points'>
        <SubscriptionPoints />
      </Modal>
      <Modal id='payment-status-direct-successfull'>
        <PaymentStatus status='approved' paymentType='direct' />
      </Modal>
      <Modal id='payment-status-subscription-successfull'>
        <PaymentStatus status='approved' paymentType='subscription' />
      </Modal>
      <Modal id='payment-status-direct-declined'>
        <PaymentStatus status='declined' paymentType='direct' />
      </Modal>
      <Modal id='payment-status-subscription-declined'>
        <PaymentStatus status='declined' paymentType='subscription' />
      </Modal>
      <Modal id={'identity-verification'}>
        <IdentityVerification />
      </Modal>
      <Modal id={'pending-screen'} closeOnClickAway={false}>
        <PendingScreen />
      </Modal>
      <Modal id={'idv-verification-success'} closeOnClickAway={false}>
        <IDVSuccess />
      </Modal>
      <Modal id={'idv-declined'}>
        <IDVDeclined />
      </Modal>
      <Modal id={'idv-change-request'}>
        <IDVChangeRequest />
      </Modal>
      <Modal id={'successful-equifax-reporting'}>
        <SuccessfulEquifaxReporting />
      </Modal>
      <Modal id={'all-gift-cards'}>
        <AllGiftCards />
      </Modal>
      <Modal id={'mfa-settings'}>
        <MFASettings />
      </Modal>
      <Modal id={'subscription-detail'}>
        <SubscriptionDetails />
      </Modal>
      <Modal id={'pay-with-crypto'} closeOnClickAway={false}>
        <PaymentProvider>
          <PayWithCrypto />
        </PaymentProvider>
      </Modal>
      <Modal id={'cancel-subscription'} closeOnClickAway={false}>
        <CancelSubscription />
      </Modal>
      <Modal id={'update-subscription-payment-method'} closeOnClickAway={false}>
        <UpdateSubscriptionPaymentMethod />
      </Modal>
      <Modal id='gift-card-details'>
        <GiftCardDetails />
      </Modal>
      <Modal id={'view-equifax-details'}>
        <ViewEquifaxDetails />
      </Modal>
      <Modal id={'add-card-success'}>
        <PaymentProvider>
          <AddCardSuccess />
        </PaymentProvider>
      </Modal>
    </>
  );
};
export default ModalContainer;
